// extracted by mini-css-extract-plugin
export default {"wrapper":"DownloadPDF_wrapper__YKeLw","wrapperHeader":"DownloadPDF_wrapperHeader__J0JQ7","pdfIcon":"DownloadPDF_pdfIcon__4LCzo"};